var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48217 1.02827C5.24724 0.792305 5.24809 0.410571 5.48405 0.175644C5.72002 -0.059282 6.10176 -0.0584384 6.33668 0.177529L7.83534 1.68282C7.97916 1.79301 8.0719 1.96652 8.0719 2.1617C8.0719 2.24658 8.05436 2.32736 8.02271 2.40062C7.99767 2.50614 7.94387 2.60621 7.86133 2.68832L6.33442 4.20719C6.09835 4.44202 5.71662 4.44101 5.48179 4.20494C5.24697 3.96887 5.24797 3.58714 5.48404 3.35231L6.07487 2.7646H2.49507C2.1621 2.7646 1.89217 2.49467 1.89217 2.1617C1.89217 1.82873 2.1621 1.5588 2.49507 1.5588H6.01036L5.48217 1.02827ZM2.58894 4.64578C2.82387 4.40981 2.82303 4.02808 2.58706 3.79315C2.35109 3.55822 1.96936 3.55907 1.73443 3.79503L0.233162 5.30295C0.0912823 5.41326 0 5.58557 0 5.7792C0 5.86191 0.0166536 5.94073 0.0467904 6.01248C0.071269 6.11994 0.125481 6.22197 0.209391 6.30543L1.7363 7.8243C1.97237 8.05913 2.3541 8.05812 2.58893 7.82205C2.82375 7.58598 2.82274 7.20425 2.58668 6.96942L1.99625 6.3821H5.57683C5.9098 6.3821 6.17973 6.11218 6.17973 5.7792C6.17973 5.44623 5.9098 5.1763 5.57683 5.1763H2.06076L2.58894 4.64578Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.8c664277.svg";
export { ForwardRef as ReactComponent };